  import * as ActionTypes from "../Types/ActionTypes";

  export const TaskAnalytics = (
    state = {
      isLoading: false,
      taskAnalyticsState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.TASK_ANALYTICS_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.TASK_ANALYTICS:
        return {
          ...state,
          isLoading: false,
          taskAnalyticsState: action.payload,
        };

      case ActionTypes.TASK_ANALYTICS_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
